import React from 'react';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import SelectValue from './SelectValue';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import './dictpicker.less'; // todo make css fit with the themes
import { getSimpleListWrapper } from '../SimpleWrapper';
import { handleFormChanged } from '@/store/allaround.store.js';
import OptionComponent from './DictOption';
import { Button } from '../../../form/FormControls.jsx';
import { refCreatePromise as refCreateSimplePromise } from '../simple.store';
import { refCreatePromise as refCreateComplexPromise } from '../../complex/product/store';
import { REF_PATH as PRODUCT_REF_PATH } from '../../complex/product/Const';
import { VERSIONS, CURRENT_RELEASE } from '@/util/version';
import filterOptions from '../../../../../node_modules/react-select/lib/utils/defaultFilterOptions';
import { List } from 'immutable';

// eslint-disable-next-line
const toLowerCase = (value) => value && value.toLowerCase ? value.toLowerCase() : value;

const createSimpleArrayComparator = sortBy => (v1, v2) => {
  const a = toLowerCase(v1[sortBy]);
  const b = toLowerCase(v2[sortBy]);

  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

const simpleComparator = (a, b) => {
  if (a < b) { return -1; }
  if (a > b) { return 1; }
  return 0;
};

export const sortedDict = (data = new List(), sortBy = 'name') => {
  if (!data) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.sort(createSimpleArrayComparator(sortBy));
  }
  if (data.toJS) {
    return data.sortBy(v => toLowerCase(v.get(sortBy)), simpleComparator);
  }
  return data;
};

const emptyElement = (parentClassName) => ({
  value: null,
  label: "",
  className: `${parentClassName}-empty-element`
})

// we need to make fuzzy matching... want it here badly
export class DictPicker extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
    this.setValue = this.setValue.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.enteredValue = '';
    this.state = {
      data: [],
      value: props.defaultValue || props.defaultValue == 0 ? props.defaultValue : '',
      showModal: false,
      errorMsg: '',
    };
  }

  componentWillMount() {
    if (this.state.value.toArray) {
      this.setState({ value: this.state.value.toArray() });
    }
    if (this.props.dict) {
      getSimpleListWrapper(this.props.dict.toUpperCase(), this.props.dict);
    }
    this.createData(this.props);
  }
  componentWillReceiveProps(props) {
    this.createData(props);
  }
  onInputChange(val) {
    this.enteredValue = val;
  }

  onChange(value) {
    const complex = this.props.dict == PRODUCT_REF_PATH;
    const refValue = value instanceof Array ? value[value.length - 1] : value;
    if (refValue != null && refValue.value == -1) {
      let refDto = undefined;
      if (complex) {
        refDto = {
          id: '',
          color: '#FFFFFF',
          productId: '',
          name: this.enteredValue,
          hidden: false,
        };
      } else {
        refDto = {
          name: this.enteredValue,
          hidden: false,
        };
      }

      if (complex) {
        refCreateComplexPromise(`/references/${this.props.dict}/api`, refDto)
          .then((response) => {
            let refItem = undefined;

            if (complex) {
              refItem = {
                value: response.productTypes[0].id,
                label: response.name,
                product: response.id,
                disabled: false,
                hidden: false,
              };
            } else {
              refItem = {
                id: response.id,
                name: response.name,
                disabled: false,
                hidden: false,
              };
            }

            if (value instanceof Array) {
              const values = value;
              values[value.length - 1] = refItem;
              this.setValue(values);
            } else {
              this.setValue(refItem);
            }
            return true;
          })
          .catch((data) => {
            this.openModal(data.name);
            return false;
          });
      } else {
        refCreateSimplePromise(refDto, this.props.dict)
          .then((response) => {
            const refItem = {
              value: response.id,
              label: response.name,
              disabled: false,
              hidden: false,
            };
            if (value instanceof Array) {
              const values = value;
              values[value.length - 1] = refItem;
              this.setValue(values);
            } else {
              this.setValue(refItem);
            }
            return true;
          })
          .catch((data) => {
            this.openModal(data.name);
            return false;
          });
      }
    } else {
      this.setValue(value);
    }
  }

  setValue(value) {
    this.setState({ value });
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc(value);
    }
    if (this.props.handleFormChanged) {
      this.props.handleFormChanged();
    }
  }

  filterOptions(options, filterValue, excludeOptions, params) {
    const value = filterValue ? filterValue.trim() : filterValue;
    let results = filterOptions == undefined
      ? options
      : filterOptions(options, value, excludeOptions, params);
    let showButton = true;
    options.forEach((option) => {
      if (option.label == value && !option.hidden) {
        showButton = false;
      }
    });
    if (CURRENT_RELEASE >= VERSIONS.Harmony && !this.props.noAddButton && filterValue
      && validateRoleConfig(['references#2'])) {
      if (showButton || results.length == 0) {
        results.unshift({
          value: -1,
          label: 'Add new item',
          hidden: false,
          disabled: false,
          style: { color: 'white', backgroundColor: '#008cba', margin: '5px 0' },
        });
      }
    }
    if (this.props.filteredData) {
      results = results
        .filter(elem => this.props.filteredData.indexOf(elem.value) >= 0);
    }
    if (this.props.excludeData) {
      results = results.filter((item) =>
        (this.props.excludeData.has ?
          !this.props.excludeData.has(item.value) :
          !this.props.excludeData.includes(item.value)));
    }
    if (this.props.excludeDataNames) {
      // eslint-disable-next-line
      results = results.filter((item) => !(item.label && this.props.excludeDataNames.has ?
        this.props.excludeDataNames.has(item.label.toLowerCase()) :
        this.props.excludeDataNames.includes(item.label.toLowerCase())));
    }
    if (this.props.filterFunc) {
      results = results.filter((item) => this.props.filterFunc(item));
    }
    return results;
  }

  openModal(errorMsg) {
    this.setState({ showModal: true, errorMsg });
  }
  closeModal() {
    this.setState({ showModal: false });
  }

  createData(props) {
    let value = undefined;
    if (!props.isChanged || props.updateDefValueOnEveryChange) {
      value = props.defaultValue || props.defaultValue === 0 ? props.defaultValue : '';
      if (value.toArray) {
        value = value.toArray();
      }
    }
    if (props.data && !Array.isArray(props.data)) {
      let newState = {
        data: [emptyElement(props.name), ...props.data.toJS().map((elem) => {
          const newElem = {
            value: elem.id,
            label: elem.name,
            hidden: this.state.value !== elem.id && elem.hidden,
            disabled: this.state.value === elem.id && elem.hidden,
          };

          const cleanedElem = elem;

          delete cleanedElem.id;
          delete cleanedElem.name;
          delete cleanedElem.hidden;

          return { ...newElem, ...cleanedElem };
        })],
      };
      if (!props.isChanged || props.updateDefValueOnEveryChange) {
        newState = { ...newState, value };
      }
      this.setState(newState);
    } else if (Array.isArray(props.data)) {
      let newState = {
        data: props.data,
      };
      if (!props.isChanged || props.updateDefValueOnEveryChange) {
        newState = { ...newState, value };
      }
      this.setState(newState);
    }
  }
  render() {
    return this.state.data ?
      (<div id={`${this.props.name}_select`}>
        <Modal bsSize="large" show={this.state.showModal} onHide={this.closeModal} >
          <Modal.Header>
            Error while adding new value to the Reference '{this.props.dict}'
          </Modal.Header>
          <Modal.Body>
            {this.state.errorMsg}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeModal}>Ok</Button>
          </Modal.Footer>
        </Modal>
        <Select
          id={this.props.name}
          disabled={this.props.disabled === undefined ? this.context.disabled : this.props.disabled}
          name={this.props.name}
          valueComponent={SelectValue}
          optionComponent={OptionComponent}
          clearable={this.props.clearable}
          options={this.state.data}
          onChange={this.onChange}
          value={this.state.value}
          filterOptions={this.filterOptions}
          multi={this.props.multi}
          onInputChange={this.onInputChange}
          backspaceToRemoveMessage=""
          openOnFocus={this.props.openOnFocus}
          matchProp="label"
          ref={(ref) => (this.props.onRef ? this.props.onRef(ref) : {})}
          placeholder={this.props.placeholder}
        />
      </div>)
      : <div></div>;
  }
}

DictPicker.propTypes = {
  data: React.PropTypes.oneOfType(
    [
      React.PropTypes.array,
      React.PropTypes.object,
    ]
  ),
  excludeData: React.PropTypes.oneOfType(
    [
      React.PropTypes.array,
      React.PropTypes.object,
    ]
  ),
  excludeDataNames: React.PropTypes.oneOfType(
    [
      React.PropTypes.array,
      React.PropTypes.object,
    ]
  ),
  dict: React.PropTypes.string,
  name: React.PropTypes.string,
  filterOptions: React.PropTypes.func,
  filterFunc: React.PropTypes.func,
  defaultValue: React.PropTypes.oneOfType(
    [
      React.PropTypes.object,
      React.PropTypes.array,
      React.PropTypes.number,
    ]
  ),
  onChangeFunc: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  readonly: React.PropTypes.bool,
  multi: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  openOnFocus: React.PropTypes.bool,
  onRef: React.PropTypes.func,
  putError: React.PropTypes.func,
  noAddButton: React.PropTypes.bool,
  updateDefValueOnEveryChange: React.PropTypes.bool,
  dictType: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  filteredData: React.PropTypes.object,
  clearable: React.PropTypes.bool,
  withEmptyValue: React.PropTypes.bool,
};

DictPicker.contextTypes = {
  disabled: React.PropTypes.bool,
};

const mapStateToProps = (state, props) => ({
  data: state.getIn(['references', props.dictType || 'simple', props.dict], new List()),
  isChanged: state.getIn(['allaround', 'formChanged'], false),
});

export default connect(mapStateToProps, (dispatch) => ({
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(DictPicker);
